module.exports = __webpack_public_path__ + "thumbnail.1f49bb65.webp";